var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThumbs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8655V8.1345H4V4.8655H0Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.73099V13H4V9.73099H0Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V3.26901H4V0H0Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.8655V8.1345H9V4.8655H5Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.73099V13H9V9.73099H5Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0V3.26901H9V0H5Z",
    fill: "#8C8C8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.8655V8.1345H14V4.8655H10Z",
    fill: "#8C8C8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.73099V13H14V9.73099H10Z",
    fill: "#8C8C8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V3.26901H14V0H10Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbs.21af9af8.svg";
export { ForwardRef as ReactComponent };